import { render, staticRenderFns } from "./FilesListTest.vue?vue&type=template&id=053f41d4&scoped=true&"
import script from "./FilesListTest.vue?vue&type=script&lang=js&"
export * from "./FilesListTest.vue?vue&type=script&lang=js&"
import style0 from "./FilesListTest.vue?vue&type=style&index=0&id=053f41d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f41d4",
  null
  
)

export default component.exports